import React from 'react';
import { useTranslation } from 'react-i18next';
import { Facebook, Twitter, Instagram, Linkedin, Mail, MapPin, Phone } from 'lucide-react';

export default function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-[#080D1A] text-white border-t border-[#1E293B]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          <div>
            <h3 className="text-xl font-bold text-[#F59E0B] mb-4 font-['Outfit']">GlobalMinerX</h3>
            <p className="text-[#64748B] mb-4 leading-relaxed">
              {t('footer.company')}
            </p>
            <div className="flex items-center space-x-3">
              <MapPin className="w-4 h-4 text-[#F59E0B]" />
              <span className="text-[#64748B] text-sm">Pan-African Platform</span>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-white">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li><a href="/how-it-works" className="text-[#64748B] hover:text-[#F59E0B] transition-colors">{t('nav.howItWorks')}</a></li>
              <li><a href="/auth" className="text-[#64748B] hover:text-[#F59E0B] transition-colors">{t('common.browse')}</a></li>
              <li><a href="/auth" className="text-[#64748B] hover:text-[#F59E0B] transition-colors">{t('auth.seller')}</a></li>
              <li><a href="/pricing" className="text-[#64748B] hover:text-[#F59E0B] transition-colors">{t('nav.pricing')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-white">{t('footer.popularMinerals')}</h4>
            <ul className="space-y-3">
              <li><a href="/auth" className="text-[#64748B] hover:text-[#F59E0B] transition-colors">{t('minerals.coltan')}</a></li>
              <li><a href="/auth" className="text-[#64748B] hover:text-[#F59E0B] transition-colors">{t('minerals.copper')}</a></li>
              <li><a href="/auth" className="text-[#64748B] hover:text-[#F59E0B] transition-colors">{t('minerals.cobalt')}</a></li>
              <li><a href="/auth" className="text-[#64748B] hover:text-[#F59E0B] transition-colors">{t('minerals.lithium')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4 text-white">{t('footer.connect')}</h4>
            <div className="space-y-3 mb-6">
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-[#F59E0B]" />
                <a href="mailto:info@globalminerx.com" className="text-[#64748B] hover:text-[#F59E0B] text-sm">info@globalminerx.com</a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-[#F59E0B]" />
                <a href="mailto:support@globalminerx.com" className="text-[#64748B] hover:text-[#F59E0B] text-sm">support@globalminerx.com</a>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-[#F59E0B]" />
                <a href="tel:+255763888863" className="text-[#64748B] hover:text-[#F59E0B] text-sm">+255 763 888 863</a>
              </div>
            </div>
            <div className="flex space-x-4">
              {[
                { Icon: Facebook, href: "https://facebook.com/globalminerx", hoverBg: "hover:bg-blue-600" },
                { Icon: Twitter, href: "https://twitter.com/globalminerx", hoverBg: "hover:bg-sky-500" },
                { Icon: Instagram, href: "https://www.instagram.com/globalminerx", hoverBg: "hover:bg-pink-600" },
                { Icon: Linkedin, href: "https://linkedin.com/company/globalminerx", hoverBg: "hover:bg-blue-700" },
              ].map(({ Icon, href, hoverBg }, i) => (
                <a key={i} href={href} target="_blank" rel="noopener noreferrer"
                  className={`w-10 h-10 bg-[#1A2440] rounded-full flex items-center justify-center ${hoverBg} transition-colors group`}>
                  <Icon className="w-5 h-5 text-[#64748B] group-hover:text-white" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-[#1E293B]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-[#64748B] text-sm mb-4 md:mb-0">
              &copy; 2025 GlobalMinerX. {t('footer.rights')}
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-[#64748B] hover:text-[#F59E0B] transition-colors">{t('footer.privacy')}</a>
              <a href="#" className="text-[#64748B] hover:text-[#F59E0B] transition-colors">{t('footer.terms')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
